import React, {Component} from 'react';
import style from '../css/gameTabs.css';
import { STARTING_SUBCATEGORY, VIRTUALS} from '../../../constants/games';
import GameCategoryTab from "../components/gameCategoryTab";
import {selectGame,updateLoadFunction} from "../../../actions/gamesActions";
import connect from "react-redux/es/connect/connect";
import GameSubTabsContainer from "./gameSubTabsContainer";
import {MATCHDAY_MODULE_TYPE} from "../../sports-book/modules/matchday/constants/identifiers";
import {PRE, RES, VID} from '../../../constants/identifiers';
import {isMatchdayNMB, isTextBasedGame} from '../modules/matchday/helpers/matchdayHelper';
import GameEventTabs from './gameEventTabs.js';
import MoreBetsHeader from '../modules/matchday/components/moreBetsHeader';
import {setselectedMatchdaySubEventIndex} from '../../../actions/eventsActions';
import {getGameCategoryIndex} from '../helpers/gameHelpers';

let gameCategoryTabsUI;
let isClickable = true;
let arrowsAppearingThreshold = 0;
let subTabArrowsAppearingThreshold = 10;
let gameCategories = [];
let scrollPositionUpdated = false;
let scrollPosition = 0;


const mapStateToProps = (state, ownProps) => {
    return {
        selectedGameIndex: state.vpp.selectedGameIndex,
        showHeader: state.vpp.showHeader, games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedMatchdayEventId: state.vpp.matchday.selectedMatchdayEventId,
        screenOrientation: state.vpp.screenOrientation,
        systemLanguage: state.vpp.systemLanguage
    };
};

class GameTabs extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();
        this.selectedMatchdayEventId = storeData.vpp.matchday.selectedMatchdayEventId;
        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            showHeader: storeData.vpp.showHeader,
            scrollPositionUpdated: false,
            games: storeData.vpp.games,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            screenOrientation: storeData.vpp.screenOrientation,
            startingSubCategory: STARTING_SUBCATEGORY,
            systemLanguage: storeData.vpp.systemLanguage
        };
        VIRTUALS.forEach((game, index) => {
            game.actualIndex = index;
            let categoryIndex = gameCategories.findIndex(category => category.name === game.category.name);
            if (gameCategories && gameCategories.length > 0 && categoryIndex >= 0) {
                if (!gameCategories[categoryIndex].games.find((g) => g.channel === game.channel)) {
                    gameCategories[categoryIndex].games.push(game);
                }
            } else {
                let gameCategory = {};
                gameCategory.name = game.category.name;
                gameCategory.order = game.category.displayOrder;
                if (!gameCategory.games) {
                    gameCategory.games = [];
                }
                gameCategory.games.push(game);
                gameCategories.push(gameCategory);
            }
        });

        gameCategoryTabsUI = gameCategories.map((gameCategory, index) => <GameCategoryTab
            gameCategory={gameCategory}
            gameCategoryindex={index} key={index} gameIndex={gameCategory.games[0].actualIndex}
            store={this.props.store}
            callback={(index) => this._clickTab(gameCategory.games[0].actualIndex)}/>);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();
        if (storeData.vpp.matchday.selectedMatchdayEventId && storeData.vpp.matchday.selectedMatchdayEventId > 0) {
            this.selectedMatchdayEventId = storeData.vpp.matchday.selectedMatchdayEventId;
        } else {
            this.selectedMatchdayEventId = undefined;
        }
        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                showHeader: storeData.vpp.showHeader,
                games: storeData.vpp.games,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                screenOrientation: storeData.vpp.screenOrientation,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
        this._setSubTabScrollArrows();
    }

    componentDidMount() {
        this._setScrollArrows();
        document.getElementById('gameTabsContainer').addEventListener('scroll', this._setScrollArrows.bind(this));
        window.addEventListener("orientationchange", this._setScrollPositionAndArrows.bind(this));
        window.addEventListener('resize', this._setScrollArrows.bind(this));
        this._manageContainerWidthAndScrollForDesktop();
    }

    componentWillUnmount() {
        document.getElementById('gameTabsContainer').removeEventListener('scroll', this._setScrollArrows.bind(this));
        window.removeEventListener('resize', this._setScrollArrows.bind(this));
        window.removeEventListener('orientationchange', this._setScrollPositionAndArrows.bind(this));
    }

    _setScrollPositionAndArrows() {
        scrollPositionUpdated = false;
        setTimeout(() => {
            this._updateScrollPosition();
        }, 200);
        setTimeout(() => {
            this._setScrollArrows();
        }, 300);
        setTimeout(() => {
            let gameTabs = document.getElementById('gameTabsContainer');
            if (gameTabs) {
                gameTabs.scrollLeft++;
            }
        }, 500);
    }

    _updateScrollPosition() {
        if (!scrollPositionUpdated) {
            let tabs = document.getElementById('gameTabsContainer');
            if (tabs) {
                tabs.scrollLeft = scrollPosition;
                scrollPositionUpdated = true;
            }
        }
    }

    _setScrollArrows() {
        let tabs = document.getElementById('gameTabsContainer');
        let hasScrollLeft = false;
        let hasScrollRight = false;

        if (tabs) {
            if (tabs.scrollLeft > arrowsAppearingThreshold) {
                hasScrollLeft = true;
            }
            if (Math.trunc(tabs.scrollWidth - tabs.scrollLeft) > tabs.clientWidth + arrowsAppearingThreshold) {
                hasScrollRight = true;
            }

            this.setState({
                ...this.state,
                hasScrollLeft,
                hasScrollRight
            });
        }
    }

    _setSubTabScrollArrows() {
        let hasSubTabScrollLeft = false;
        let hasSubTabScrollRight = false;
        let tabs = document.getElementById('gameSubTabContainer');
        if (tabs) {
            if (tabs.scrollLeft > subTabArrowsAppearingThreshold) {
                hasSubTabScrollLeft = true;
            }
            if (tabs.scrollWidth - tabs.scrollLeft > tabs.clientWidth + subTabArrowsAppearingThreshold) {
                hasSubTabScrollRight = true;
            }

            this.setState({
                ...this.state,
                hasSubTabScrollLeft,
                hasSubTabScrollRight
            });
        }
    }

    _clickTab(index) {
        if (this.props.store && isClickable) {
            isClickable = false;
            setTimeout(() => {
                isClickable = true
            }, 300);
            let elem = document.getElementById('gameTabsContainer');
            if (elem) {
                scrollPosition = elem.scrollLeft;
                scrollPositionUpdated = false;
            }
            if(!this.props.store.getState().vpp.onLoad){
                this.props.store.dispatch(selectGame(index, this.props.store));
                this.props.store.dispatch(setselectedMatchdaySubEventIndex(0, this.props.store));
            }
            else{
                this.props.store.dispatch(updateLoadFunction(this.props.store));
            }
        }
    }

    _animateScrollLeft() {
        const tabWidth = document.getElementById('gameCategoryTab_0').offsetWidth;
        const interval = 2;
        let elem = document.getElementById('gameTabsContainer');
        let scroll = 0;
        let id = setInterval(scrollLeft, interval);

        function scrollLeft() {
            if (scroll === tabWidth) {
                let balanceScroll = Math.ceil(elem.scrollLeft);
                if (balanceScroll > 1 && balanceScroll < tabWidth) {
                    scroll = (tabWidth - balanceScroll);
                } else {
                    elem.scrollLeft--;
                    clearInterval(id);
                }
            } else {
                elem.scrollLeft--;
                scroll++;
            }
        }
    }

    _animateScrollRight() {
        const tabWidth = document.getElementById('gameCategoryTab_0').offsetWidth;
        const interval = 2;
        let elem = document.getElementById('gameTabsContainer');
        let scroll = 0;
        let scrollLeft = Math.ceil(elem.scrollLeft);
        let id = setInterval(scrollRight, interval);

        function scrollRight() {
            if (tabWidth != scroll) {
                elem.scrollLeft = scrollLeft++;
                scroll++;
            } else {
                let balanceScroll = Math.ceil((elem.scrollWidth - elem.clientWidth) - elem.scrollLeft);
                if (balanceScroll > 1 && balanceScroll < tabWidth) {
                    scroll = (tabWidth - balanceScroll);
                } else {
                    elem.scrollLeft = scrollLeft++;
                    clearInterval(id);
                }
            }
        }
    }

    _animateSubTabScrollLeft() {
        const tabWidth = document.getElementById('gamesubTab_1').offsetWidth;
        const interval = 2;
        let elem = document.getElementById('gameSubTabContainer');
        let scroll = 0;
        let id = setInterval(scrollLeft, interval);

        function scrollLeft() {
            if (scroll === tabWidth) {
                clearInterval(id);
            } else {
                scroll++;
                elem.scrollLeft--;
            }
        }
    }

    _animateSubTabScrollRight() {
        const tabWidth = document.getElementById('gamesubTab_1').offsetWidth;
        const interval = 2;
        let elem = document.getElementById('gameSubTabContainer');
        let scroll = 0;
        let id = setInterval(scrollRight, interval);

        function scrollRight() {
            if (scroll === tabWidth) {
                clearInterval(id);
            } else {
                scroll++;
                elem.scrollLeft++;
            }
        }
    }

    _scrollGameTabs(gameIndex) {
        if (gameIndex !== undefined) {
            const tabWidth = document.getElementById('gameCategoryTab_0').offsetWidth;
            let gameTabsContainer = document.getElementById('gameTabsContainer');
            let scrollDistance = tabWidth * getGameCategoryIndex(gameIndex);
            gameTabsContainer.scrollLeft = gameTabsContainer.scrollLeft + scrollDistance;
        }
    }

    _manageContainerWidthAndScrollForDesktop() {
        let intvl = setInterval(() => {
            let elem = document.getElementById('gameTabsContainer');
            if (window.innerWidth > 950 && elem && window.innerWidth !== elem.offsetWidth) {
                this._scrollGameTabs(this.props.store.getState().vpp.selectedGameIndex);
                setTimeout(() => {
                    this._setScrollArrows()
                }, 300);
                clearInterval(intvl);
            }
        }, 100);
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let arrowStyle = this.state.showHeader ? '' : style.arrowHideHeader;
        let subTabArrowStyle = this.state.showHeader ? '' : style.subTabarrowHideHeader;
        let scrollLeft = this.state.hasScrollLeft
            ? <div className={`${style.leftArrow} ${arrowStyle} `} id={'gameScrollLeft'}
                   onClick={() => this._animateScrollLeft()}/>
            : '';
        let scrollRight = this.state.hasScrollRight
            ? <div className={`${style.rightArrow} ${arrowStyle}`} id={'gameScrollRight'}
                   onClick={() => this._animateScrollRight()}/>
            : '';

        let subTabScrollLeft;
        let subTabScrollRight;
        let containerStyle, matchdayEventTabs, matchdayMoreBetsHeader;
        let game = this.state.games[this.props.store.getState().vpp.selectedGameIndex];
        let subTabContainer = <GameSubTabsContainer store={this.props.store} gameCategories={gameCategories}/>

        if (game.type === MATCHDAY_MODULE_TYPE && !isTextBasedGame(game.channel)) {
            subTabScrollLeft = this.state.hasSubTabScrollLeft
                ? <div className={`${style.subTabLeftArrow} ${subTabArrowStyle} `} id={'subTabScrollLeft'}
                       onClick={() => this._animateSubTabScrollLeft()}/>
                : '';
            subTabScrollRight = this.state.hasSubTabScrollRight
                ? <div className={`${style.subTabRightArrow} ${subTabArrowStyle}`} id={'subTabScrollRight'}
                       onClick={() => this._animateSubTabScrollRight()}/>
                : '';
            // check is displaying morebets screen in matchday
            if (this.selectedMatchdayEventId) {
                matchdayMoreBetsHeader =
                    <MoreBetsHeader store={this.props.store} selectedMatchdayEventId={this.selectedMatchdayEventId}/>
            } else if ((this.props.store.getState().vpp.selectedEventIndex !== 0)
                || (this.props.store.getState().vpp.selectedEventIndex === 0
                    && game.controllerState && game.controllerState[1] && (game.controllerState[1] === PRE))) {
                matchdayEventTabs = (<div className={style.eventTabsContainer} id={"matchdayEventTabs"}>
                    <GameEventTabs id='gameEventTabs' store={this.props.store}
                                   hasSelectedGameFutureEvents={true}/>
                </div>);
            }
            if (this.props.store.getState().vpp.selectedEventIndex === 0
                && game.controllerState && game.controllerState[1]
                && game.controllerState[1] !== PRE && (isMatchdayNMB(storeData) || game.controllerState[1] === VID
                    || game.controllerState[1] === RES)) {
                containerStyle = `${style.gameSubTabContainer} ${style.gameSubTabContainerMatchday}`
            } else {
                subTabContainer = undefined;
            }
        } else {
            containerStyle = style.gameSubTabContainer;
        }

        let subtabComponent = subTabContainer ? (<div id={'gameSubTabContainer'} className={containerStyle}
                                                      onScroll={this._setSubTabScrollArrows.bind(this)}>
            {subTabContainer} {subTabScrollLeft} {subTabScrollRight} </div>) : '';

        return (
            <div className={style.gameTabsOuterContainer}>
                <div className={style.gameTabsContainer} ref={this.props.containerRef} id='gameTabsContainer'>
                    <div id={this.props.id} className={style.gameTabs}>
                        {gameCategoryTabsUI}
                    </div>
                </div>
                <div className={style.gameTabScroll}>
                    {scrollLeft}
                    {scrollRight}
                </div>
                {subtabComponent}
                {matchdayEventTabs}
                {matchdayMoreBetsHeader}
            </div>
        );
    }
}

export default connect(mapStateToProps)(GameTabs);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/gameTabs.js